import { render } from "./DeviceTabBracelet.vue?vue&type=template&id=250f3e53"
import script from "./DeviceTabBracelet.vue?vue&type=script&lang=js"
export * from "./DeviceTabBracelet.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__